
import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import {
//   CustomQuery
// } from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useGetDiscount = (id: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useGetDiscountcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  // const result = sharedRef(null, `useGetDiscount-${id}`);
  // // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useGetDiscount-loading-${id}`);
  // // Shared ref holding errors from the methods
  const error = sharedRef({}, `useGetDiscount-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const getDiscount = async (customQuery) => {
    try {
      loading.value = true;
      // result.value = null;
      const res = await context.$xbuy.api.getDiscount(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        // result.value = res.data;
        error.value = null;
        return res.data;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    getDiscount: getDiscount,
    // result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  };
};
